import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { CriteriaProvider } from "presentation/store/Criteria/CriteriaProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { CriteriaMasterView } from "presentation/view/section/Criteria/CriteriaMasterView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const DocumentSeparationCriteriaContMain = () => {
    return <ANAInfoWrapper permission={Permission.DOCUMENT_SEPARATION_CRITERIA_MAINTENANCE}>
        <MessageBarWrapper>
            <CriteriaProvider>
                <GridStyles/>
                <CriteriaMasterView entrypoint = {'DOCSEP'}/>
            </CriteriaProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default DocumentSeparationCriteriaContMain;